<template>
<section class=" h-full  w-full flex flex-wrap bg-gray-50 justify-start  ">

    <!-- Filtros de fecha personalizados -->
    <div class="w-full bg-white p-4 mb-4 shadow-sm border-b">
        <div class="flex flex-wrap gap-4 items-center">
            <!-- Selector de tipo de filtro -->
            <div class="flex flex-col">
                <label class="text-sm font-medium text-gray-700 mb-1">Tipo de filtro:</label>
                <select v-model="tipoFiltroFecha" @change="cambiarTipoFiltro" 
                        class="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                    <option value="mes">Por mes</option>
                    <option value="personalizado">Fechas personalizadas</option>
                </select>
            </div>

            <!-- Filtro por mes -->
            <div v-if="tipoFiltroFecha === 'mes'" class="flex flex-col">
                <label class="text-sm font-medium text-gray-700 mb-1">Seleccionar mes:</label>
                <input type="month" v-model="mesSeleccionado" @change="aplicarFiltroMes" 
                       class="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            </div>

            <!-- Filtro personalizado -->
            <div v-if="tipoFiltroFecha === 'personalizado'" class="flex flex-col">
                <label class="text-sm font-medium text-gray-700 mb-1">Fecha inicio:</label>
                <input type="date" v-model="fechaInicioPersonalizada" @change="aplicarFiltroPersonalizado" 
                       class="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            </div>

            <div v-if="tipoFiltroFecha === 'personalizado'" class="flex flex-col">
                <label class="text-sm font-medium text-gray-700 mb-1">Fecha fin:</label>
                <input type="date" v-model="fechaFinPersonalizada" @change="aplicarFiltroPersonalizado" 
                       class="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            </div>

            <!-- Botones de acciones rápidas -->
            <div class="flex flex-col">
                <label class="text-sm font-medium text-gray-700 mb-1">Acciones rápidas:</label>
                <div class="flex gap-2">
                    <button @click="establecerMesActual" 
                            class="px-3 py-2 bg-blue-500 text-white text-xs rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500">
                        Mes actual
                    </button>
                    <button @click="establecerMesAnterior" 
                            class="px-3 py-2 bg-gray-500 text-white text-xs rounded hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500">
                        Mes anterior
                    </button>
                    <button @click="establecerUltimos3Meses" 
                            class="px-3 py-2 bg-green-500 text-white text-xs rounded hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500">
                        Últimos 3 meses
                    </button>
                </div>
            </div>

            <!-- Mostrar rango actual -->
            <div class="flex flex-col">
                <label class="text-sm font-medium text-gray-700 mb-1">Rango actual:</label>
                <div class="text-sm text-gray-600 bg-gray-100 px-3 py-2 rounded">
                    <span class="font-medium">{{ formatDateES(fecha[0]) }}</span> - 
                    <span class="font-medium">{{ formatDateES(fecha[1]) }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Mostrar tabla cuando hay datos -->
    <Tabla v-bind:key="reftable" v-if="data.length>0" :add="false" :columns="headings" :rows="data" :filtros="['cliente','vendedor','idventa','id','status_verificar']" :buscarp="buscar" :filtroApi="false" :paginate="false" />
    
    <!-- Mostrar mensaje cuando no hay datos -->
    <div v-else-if="data.length === 0" class="w-full h-full flex items-center justify-center">
        <div class="text-center p-8">
            <p class="text-gray-500 text-lg">No hay datos para mostrar</p>
            <p class="text-gray-400 text-sm mt-2">Intenta ajustar los filtros de búsqueda o el rango de fechas</p>
        </div>
    </div>

    <el-drawer @closed="getData()" v-model="viewCotizacion" title="" :with-header="false" :size="$isMobile()?'100%':'100%'">
        <!--content-->
        <div class="h-full    flex flex-wrap content-start justify-center w-full  outline-none focus:outline-none overflow-y-scroll">
            <!--header-->

                 
                
                <alert_component tipo="success" title="Pedido por revisar y asignar " text="en esta sección se revisara e imprimira el formato de producion, ademas de asignar el empleado asignado a la produccion del producto, al precionar el boton de imprimir se genera un pdf y se marca como revisado los productos de la categoria."></alert_component>
              
               <div class="w-full flex flex-wrap" id="titulo_print">
                <div class="h-10 text-black text-base uppercase bg-gray-300 align-middle w-full flex flex-wrap " >
                    <div class="w-full h-10 bg-yellow-400 flex flex-wrap justify-start content-center font-extrabold px-5"><span class="align-middle">fecha impresión</span>:({{ formadivateTimeLT(fecha_impresion) }})</div>
                      </div>
                <div class="h-10 text-black text-base uppercase bg-gray-300 align-middle w-full flex flex-wrap" >
                    <div class="w-3/12 h-10 bg-yellow-300 flex flex-wrap justify-center content-center font-extrabold"><span class="align-middle">#Venta</span></div>
                    <div class="w-3/12 h-10 bg-yellow-200 flex flex-wrap justify-center content-center font-extrabold"><span class="align-middle">{{el_cotizacion.idventa}}</span></div>
                    <div class="w-3/12 h-10 bg-yellow-300 flex flex-wrap justify-center content-center font-extrabold"><span class="align-middle">Cliente</span></div>
                    <div class="w-3/12 h-12 bg-yellow-200 align-middle flex flex-wrap justify-center content-center"><span>{{ el_cotizacion.clientes.name}} {{ el_cotizacion.clientes.apellido_p}} {{ el_cotizacion.clientes.apellido_m}}</span></div>
                 </div>
                </div>
            <!--body-->
            <div class="w-full   flex  flex-wrap justify-start  content-start z-20 h-full">

                <div class="h-full bg-white px-2 flex flex-wrap w-full overflow-y-hidden">

                    <VistaProduccion v-bind:key="viewCotizacion" :cotizacion="el_cotizacion"  :edit="true"></VistaProduccion>

                </div>

            </div>

        </div>
        <template #footer>
            <div class="dialog-footer">
                <btn_component :text="'Cerrar'" :tipo="'info'"   @click="viewCotizacion=false"></btn_component>
                <!--<button class=" bg-blue-500 px-2 py-1 mx-2 rounded border-2  border-black" @click="viewCotizacion=false">Cerrar</button>-->

            </div>
        </template>
    </el-drawer>

</section>
</template>

    
    
<script>
import {
    emitter
} from "../../../mitt.js";
import {
    useUserStore
} from '../../../stores/user'
import Tabla from "@/components/Tabla.vue";
import VistaProduccion from "@/components/VistaProduccion.vue";
import generales from "@/functions/generales";
import metodos_pagos from "@/Services/metodos_pagos";
import abonos from "@/Services/abonos";
import cotizaciones from "@/Services/cotizaciones";

import {
    filter
} from "lodash";
export default {
    components: {
        Tabla,
        VistaProduccion
    },
    mixins: [generales, cotizaciones, metodos_pagos, abonos],
    data() {
        const user = useUserStore()

        return {
            headings: [

                {
                    key: 'id',
                    name: '# Cot',
                    show: true,
                    class:'min-w-[100px]'
                },
                {
                    key: 'idventa',
                    name: '# venta',
                    show: true,
                    class:'min-w-[100px]'
                },
                {
                    key: 'fecha_venta',
                    name: 'Fecha Pedido',
                    show: true,
                    class:'min-w-[200px]'
                },

                {
                    key: 'cliente',
                    name: 'Cliente',
                    show: true,
                    class:'min-w-[300px] text-base font-extrabold'
                },

                {
                    key: 'vendedor',
                    name: 'Usuario',
                    show: true,
                    class:'min-w-[300px] text-base font-extrabold'
                },
                {

                    key: 'status_revisar',
                    name: 'Estatus producción',
                    show: true,
                    class:'w-[200px]'
                },

                /* {
                     key: 'edit',
                     name: 'Editar',
                     show: true
                 },*/

            ],
            dates: [],
            upbuton: 0,
            el_cotizacion: {
                id: 0
            },
            open: false,
            user: user.getAll(),
            metodos_data: [],
            data: [],
            actionModal: null,
            viewCotizacion: false,
            showM: false,
            info: '',
            id: 0,
            obj_abono: {
                cotizacion: 0,
                tipo_pago: '',
                impuesto: 0,
                comision: 0,
                total: 0,
            },
            addAbono: false,
            tipo_metodo: null,
            buscar: 'all',
            pagina: 1,
            limit: 0,
            reftable: 0,
            tipo: 'produccion',
            fecha_impresion:new Date(),
            fecha: [this.getFirstDayOfMonth(), this.getLastDayOfMonth()],
            
            // Nuevas variables para filtros de fecha
            tipoFiltroFecha: 'mes', // 'mes' o 'personalizado'
            mesSeleccionado: this.getCurrentYearMonth(),
            fechaInicioPersonalizada: this.getFirstDayOfMonth(),
            fechaFinPersonalizada: this.getLastDayOfMonth(),

        }

    },
    mounted() {
        emitter.on('closeProduccion', () => {

            this.closeProduccion();

        });
    },
    async created() {
        if (this.$route.query.hasOwnProperty('cid')) {
            this.buscar = this.$route.query.cid;
            
            // Cuando hay parámetro cid, usar rango amplio (desde enero del año actual)
            const now = new Date();
            const primeroDEnero = new Date(now.getFullYear(), 0, 1); // 1 de enero del año actual
            const fechaActual = new Date(); // Fecha actual
            
            this.fechaRango = [primeroDEnero, fechaActual];
            this.fecha = [primeroDEnero, fechaActual];
            
            // Configurar filtro personalizado
            this.tipoFiltroFecha = 'personalizado';
            this.fechaInicioPersonalizada = this.formatDateEN(primeroDEnero);
            this.fechaFinPersonalizada = this.formatDateEN(fechaActual);
            
            console.log('🔍 Parámetro CID detectado en producción revisar:', this.buscar, 'Usando rango amplio:', primeroDEnero, 'a', fechaActual);
            
            // Cargar datos directamente con el rango amplio
            this.getData();
        } else {
            // Aplicar filtro de mes actual por defecto cuando no hay CID
            this.aplicarFiltroMes();
        }
        
        await this.getDataMetodos();
    },
    methods: {
        IsMov() {

            //return true;
            return this.$isMobile()
        },
        
        // ===== MÉTODOS PARA FILTROS DE FECHA =====
        getCurrentYearMonth() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            return `${year}-${month}`;
        },
        
        formatDateES(date) {
            if (!date) return '';
            const d = new Date(date);
            return d.toLocaleDateString('es-ES');
        },
        
        cambiarTipoFiltro() {
            console.log('🔄 Cambiando tipo de filtro a:', this.tipoFiltroFecha);
            if (this.tipoFiltroFecha === 'mes') {
                this.aplicarFiltroMes();
            } else {
                this.aplicarFiltroPersonalizado();
            }
        },
        
        aplicarFiltroMes() {
            if (!this.mesSeleccionado) return;
            
            const [year, month] = this.mesSeleccionado.split('-');
            const firstDay = new Date(year, month - 1, 1);
            const lastDay = new Date(year, month, 0);
            
            this.fecha = [firstDay, lastDay];
            console.log('📅 Aplicando filtro por mes:', this.mesSeleccionado, 'Rango:', firstDay, 'a', lastDay);
            this.getData();
        },
        
        aplicarFiltroPersonalizado() {
            if (!this.fechaInicioPersonalizada || !this.fechaFinPersonalizada) return;
            
            const fechaInicio = new Date(this.fechaInicioPersonalizada);
            const fechaFin = new Date(this.fechaFinPersonalizada);
            
            // Validar que la fecha de inicio no sea mayor que la fecha fin
            if (fechaInicio > fechaFin) {
                alert('La fecha de inicio no puede ser mayor que la fecha de fin');
                return;
            }
            
            this.fecha = [fechaInicio, fechaFin];
            console.log('📅 Aplicando filtro personalizado:', fechaInicio, 'a', fechaFin);
            this.getData();
        },
        
        establecerMesActual() {
            this.tipoFiltroFecha = 'mes';
            this.mesSeleccionado = this.getCurrentYearMonth();
            this.aplicarFiltroMes();
        },
        
        establecerMesAnterior() {
            const now = new Date();
            const mesAnterior = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            const year = mesAnterior.getFullYear();
            const month = String(mesAnterior.getMonth() + 1).padStart(2, '0');
            
            this.tipoFiltroFecha = 'mes';
            this.mesSeleccionado = `${year}-${month}`;
            this.aplicarFiltroMes();
        },
        
        establecerUltimos3Meses() {
            const now = new Date();
            const hace3Meses = new Date(now.getFullYear(), now.getMonth() - 2, 1);
            const finMesActual = new Date(now.getFullYear(), now.getMonth() + 1, 0);
            
            this.tipoFiltroFecha = 'personalizado';
            this.fechaInicioPersonalizada = this.formatDateEN(hace3Meses);
            this.fechaFinPersonalizada = this.formatDateEN(finMesActual);
            this.aplicarFiltroPersonalizado();
        },
        // ===== FIN MÉTODOS PARA FILTROS DE FECHA =====
        accionProduccion(row) {

            

            this.getDataCotizacionId(row.id)
            //this.el_cotizacion = row;
           

        },

        async getDataCotizacionId(id) {
            emitter.emit("loading", true)

            let dat = {
                id: id
            }

            let r = await cotizaciones.SHOW(dat).then(response => {

                if (response != null && !response.hasOwnProperty('error')) {

                    this.el_cotizacion = response;
                    this.viewCotizacion = true;
                   
                    emitter.emit("loading", false)
                    //this.$router.push('/app/'); 
                } else {
                    
                    emitter.emit("alerta_show", response.error);
                    emitter.emit("loading", false)
                }

                return;
            });
            return r;
        },
        async pageChangue(val) {

            this.page = val;
            await this.getData();

        },

        infoModal(row) {
            this.info = row;
           
        },
        paginaSearch(pagina) {
            
            this.pagina = pagina;

            this.getData();
        },

        addRow() {
            this.showM = !this.showM;
            this.limpiar()
        },
        limpiar() {
            this.viewCotizacion = false;
        },
        closeProduccion() {
            this.viewCotizacion = false;
        },
        buscador(row) {
            if (String(row.telefono).toUpperCase().search(String(this.buscar).toUpperCase()) != -1 || (String(row.nombre)).toUpperCase().search(String(this.buscar).toUpperCase()) != -1) {
                return true;
            } else {
                return false;
            }
        },
        getColumns() {
            let col = 0;
            this.headings.forEach(element => {
                if (element.show) {
                    col = col + 1
                }
            });
            return col;
        },

        buscarGet(text) {
            this.buscar = text;
            if (text == '') {
                this.buscar = 'all';
            }
            this.getData();
        },

        async getData() {
            this.showM = false;
            this.actionModal = null;
            emitter.emit("loading", true)
            let dat = {
                search: this.buscar,
                page: this.pagina,
                tipo: this.tipo,
                inicio: this.formatDateEN(this.fecha[0]),
                fin: this.formatDateEN(this.fecha[1]),
                data: {}
            }

            await cotizaciones.GET_PRODUCCION_REVISAR_03(dat).then(response => {

                if (response != null && !response.hasOwnProperty('error')) {

                    // Extraer el array de datos del objeto de respuesta
                    this.data = response.data || [];
                    console.log('Datos cargados:', this.data.length, 'registros');

                   
                    this.reftable = this.reftable + 1;

                    //this.$router.push('/app/'); 
                } else {

                    emitter.emit("alerta_show", response.error);

                }
                emitter.emit("loading", false)
            });
        },

        async getDataMetodos() {
            try {
                const response = await metodos_pagos.GET(this.user.token);
                if (response != null && !response.hasOwnProperty('error')) {
                    this.metodos_data = response;
                } else {
                    console.warn('Error al cargar métodos de pago:', response?.error);
                }
            } catch (error) {
                console.error('Error en getDataMetodos:', error);
            }
        },

        async Verificar(status) {

            let dat = {
                id: this.el_cotizacion.id,
                status_verificar: status,
                observaciones_verificar: this.el_cotizacion.observaciones_verificar

            }
            if (status == 'APROBADA') {
                dat.status_produccion = 'EN PRODUCCION'
            }

            if (this.el_cotizacion.id == 0) {
                //this.crear(dat)
            } else {
                this.editar(dat)
            }
        },

        async editar(dat) {
            emitter.emit("loading", true)

            await cotizaciones.EDITAR_PARAMS(dat).then(response => {

                if (response != null && !response.hasOwnProperty('error')) {

                    this.el_cotizacion = response;
                    //this.$router.push('/app/'); 
                } else {

                    // emitter.emit("alerta_show",response.msg);

                }
                this.showM = false;
                this.limpiar();
                emitter.emit("loading", false)
            });
        },

    }
}
</script>
